import { ApiError, FormErrors } from '../models/ApiError';
import { defaultErrorHandler } from '../services/ErrorHandler';

/**
 * Utility class for handling form errors
 */
export class FormErrorHandler {
  /**
   * Extract field-specific errors from ApiError
   */
  static extractFieldErrors(error: ApiError): FormErrors {
    return defaultErrorHandler.extractFieldErrors(error);
  }

  /**
   * Check if error contains form validation errors
   */
  static hasFormErrors(error: ApiError): boolean {
    return defaultErrorHandler.hasFormErrors(error);
  }

  /**
   * Get general form error message (non-field-specific)
   */
  static getGeneralFormError(error: ApiError): string | null {
    return defaultErrorHandler.getGeneralFormError(error);
  }

  /**
   * Convert form errors to a list of strings
   */
  static formErrorsToList(errors: FormErrors): string[] {
    return defaultErrorHandler.formErrorsToList(errors);
  }
}

